<template>
  <b-modal id="dailyPlanMoveModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.dailyplan.moveHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="form-group">
          <label class="form-control-label">{{$t('modals.dailyplan.idUserData')}}:</label>
          <fg-input>
            <el-select
              class="select-default"
              :placeholder="$t('modals.dailyplan.idUserData')"
              filterable
              v-model="idUserData">
              <el-option v-for="option in servicemenOptions"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.name + ' ' + option.surname"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
        </div>
      </b-col>
      <b-col>
        <div class="form-group">
          <label class="form-control-label">{{$t('modals.dailyplan.date')}}:</label>
          <fg-input>
            <el-date-picker
              :picker-options="{firstDayOfWeek: 1}"
              v-model="date"
              :placeholder="$t('modals.dailyplan.date')"
              type="date">
            </el-date-picker>
          </fg-input>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="form-group">
          <label class="form-control-label">{{$t('modals.dailyplan.moveReason')}}:</label>
          <textarea v-model="moveReason" class="form-control"></textarea>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button class="btn btn-success" @click="move()">{{ $t('buttons.submit') }}</b-button>
        <b-button class="btn btn-danger" @click="closeModal()">{{ $t('buttons.cancel') }}</b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import getId from '@/utils/getIdFromLink'

export default {
  name: 'DailyPlanMoveModal',
  computed: {
    show () {
      return this.$store.state.modals.dailyplan.move.show
    },
    dailyPlanItemObject () {
      return this.$store.state.modals.dailyplan.move.dailyPlanItemObject
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'dailyPlanItemObject': function (val) {
      this.openModal()
    }
  },
  data () {
    return {
      dailyPlanItem: null,
      date: '',
      moveReason: '',
      idUserData: null,
      servicemenOptions: []
    }
  },
  methods: {
    move () {
      if (this.dailyPlanItem.confirmed === 1) {
        let id = this.getIdLink(this.dailyPlanItem['@id'])
        let date = this.$moment(this.date).format('YYYY-MM-DD')
        let params = {
          idUserData: parseInt(this.getIdLink(this.idUserData)),
          date: date,
          moveReason: this.moveReason
        }
        this.$http
          .post('api/e_x_c_m_daily_plan_items/' + id + '/move',
            params
          )
          .then(response => {
            this.$store.state.modals.dailyplan.move.moved = 1
            this.closeModal()
          })
          .catch(error => {
            this.isLoading = false
            if (error.response.status === 400) {
              let text = ''
              for (let i in error.response.data) {
                text += error.response.data[i] + '\n'
              }
              this.$Swal({
                type: 'warning',
                title: text,
                timer: 2500
              })
            }
            console.log(error)
          })
      }
    },

    getServicemen () {
      let params = {
        'pagination': false,
        'isCompany': 0,
        'state': 1,
        'idClientType': 5
      }
      this.servicemenOptions = []
      this.$http.get('api/user_datas', {
        params
      })
        .then(response => {
          this.servicemenOptions = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },

    openModal () {
      if (this.show === 1 && this.dailyPlanItemObject) {
        this.dailyPlanItem = Object.assign({}, this.dailyPlanItemObject)
        // this.idUserData = this.dailyPlanItem
        this.$store.state.modals.dailyplan.move.show = 0
        this.$store.state.modals.dailyplan.move.dailyPlanItemObject = null
        this.$bvModal.show('dailyPlanMoveModal')
        this.getServicemen()
      }
    },
    getIdLink (link) {
      return getId(link)
    },
    closeModal () {
      this.$bvModal.hide('dailyPlanMoveModal')
    },
    resetData () {
      this.date = ''
      this.serviceman = null
    }
  }
}
</script>
